import React, {useState} from 'react';
import {Switch, Route} from 'react-router-dom';
import classNames from 'classnames';

import {Layouts} from '@components';
import paths from '@paths';
import * as routing from './routing';
import * as hooks from './hooks';
import enhance from './enhancer';
import {RoutesProps} from './types';

import './index.scss';

const Routes: React.FC<RoutesProps> = props => {
  const [loading, setLoading] = useState(true);
  const [isAuthed, setIsAuthed] = useState(false);
  const [isDisplay, setIsDisplay] = useState(true);

  hooks.useMount(setLoading, setIsAuthed, props.actions);
  hooks.useUpdate(setIsDisplay, props.location.pathname);

  if (loading) {
    return null;
  }

  if (!isAuthed) {
    return (
      <div className="a__routes">
        <div className="b__before">
          <Switch>
            {routing.before.map((route: AppRoute) => (
              <Route
                key={route.path}
                path={route.path}
                exact={route.exact}
                component={route.component}
              />
            ))}
          </Switch>
        </div>
      </div>
    );
  }

  return (
    <div className="a__after-routes">
      <div className={classNames('b__sidebar', {hide: !isDisplay})}>
        <Layouts.SideBar.Main history={props.history} />
      </div>
      <div className={classNames('b__after', {full: !isDisplay})}>
        <div
          className={classNames('w__header', {
            full: !isDisplay,
            hidden: isAuthed && props.location.pathname === paths.landing.main,
            answer:
              !isDisplay &&
              props.location.pathname.includes(`${paths.safety.main}`),
          })}
        >
          <Layouts.Header.After me={props.me} history={props.history} />
        </div>
        <Switch>
          {routing.after.map((route: AppRoute) => (
            <Route
              key={route.path}
              path={route.path}
              exact={route.exact}
              component={route.component}
            />
          ))}
        </Switch>
        <div
          className={classNames(
            'w__footer',
            {full: !isDisplay},
            {
              answer:
                !isDisplay &&
                props.location.pathname.includes(`${paths.safety.main}`),
            }
          )}
        >
          <Layouts.Footer.Main />
        </div>
      </div>
    </div>
  );
};

export default enhance((props: any) => <Routes {...props} />);
